<template>
  <div>
    <div class="fixed z-30 top-0 left-0 w-full max-lg:bg-white max-lg:border-b lg:h-0">
      <div class="float-left max-lg:hidden">
        <NuxtLink class="block p-2 lg:p-3 mt-1" to="/">
          <img class="h-4" src="~/assets/images/fans48-logo.svg">
        </NuxtLink>
      </div>
      <div class="float-left lg:hidden">
        <div v-if="isTeamPage && team.name">
          <NuxtLink :to="{ name: 'team', params: { team: team.slug }}" class="block p-2 lg:p-3">
            <div class="flex items-center gap-2">
              <TeamLogo
                class="w-8 h-8 rounded-md overflow-hidden -my-1"
                :name="team.name"
                :slug="team.slug"
                :logo="team.logo"
                size="64"
                :alt="team.abbr"
              />
              <div class="font-bold">{{ team.name }}</div>
            </div>
          </NuxtLink>
        </div>
        <div v-else-if="isLeaguePage && league.name">
          <NuxtLink :to="{ name: 'leagues-league', params: { league: league.slug }}" class="block p-2 lg:p-3">
            <div class="flex items-center gap-2">
              <LeagueLogo
                v-if="league.slug"
                class="w-8 h-8 rounded-md overflow-hidden -my-1"
                :name="league.name"
                :slug="league.slug"
              />
              <div class="font-bold">{{ league.name }}</div>
            </div>
          </NuxtLink>
        </div>
        <div v-else>
          <NuxtLink class="block p-2 lg:p-3 mt-1" to="/">
            <img class="h-4" src="~/assets/images/fans48-logo.svg">
          </NuxtLink>
        </div>
      </div>
      <div class="float-right">
        <div class="flex items-center gap-2" v-auto-animate>
          <TeamFavoriteButton v-if="isTeamPage && !isFavorite" />
          <button class="p-2 lg:p-3" @click="toggleDrawer()">
            <AtomIcon name="circle-ellipsis-vertical" class="text-2xl text-sky-900" />
          </button>
        </div>
      </div>
    </div>
    <div class="h-10 lg:h-0"></div>
    <div class="h-1" v-if="isTeamPage && team?.theme"></div>
    <div class="fixed z-50 h-1 top-10 lg:top-0 w-full" :style="{ background: useHexToRgba(team?.theme?.accent, 1) }" v-if="isTeamPage && team?.theme"></div>
  </div>
</template>

<script setup>
const route = useRoute()
const user = useUserStore()
const team = useTeamStore()
const league = useLeagueStore()
const { toggleDrawer } = useAppDrawer()

const isFavorite = computed(() => user?.favoriteIds.includes(team.id))
const isTeamPage = computed(() => route.name === 'team' || route.name.startsWith('team-'))
const isLeaguePage = computed(() => route.name === 'leagues-league' || route.name.startsWith('leagues-'))
</script>